import { Address, Restaurant } from '@/models';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

const ONE_MILE = 1610; // 1609.34 meters in a mile

@Component({
  name: 'CmgNearbyRestaurantAlert',
})
export default class CmgNearbyRestaurantAlert extends Vue {
  @Prop({ type: Object })
  address?: Address;

  @Prop({ type: Object })
  restaurant?: Restaurant;

  @Prop({ type: Boolean })
  isPickup?: boolean;

  isNearbyChipotle = false;

  get showNearbyRestaurantAlert(): boolean {
    return this.isNearbyChipotle;
  }

  get infoIcon(): string {
    return this.$appStore.state.cms.images.icons.info.default;
  }

  get hasMapsLoaded() {
    return this.$appStore.state.findAChipotle.hasGoogleMapsLoaded;
  }
  
  @Watch('hasMapsLoaded', { immediate: true })
  onMapsLoaded(hasMapsLoaded: boolean) {
    if (hasMapsLoaded && this.isPickup) {
        this.checkForNearbyChipotleLocations();
    }
  }

  @Watch('address')
  onAddressChanged(address: Address, oldAddress: Address) {
    if (this.isPickup) {
        this.checkForNearbyChipotleLocations();
    } 
    else {
        this.isNearbyChipotle = false;
    }
  }

  async checkForNearbyChipotleLocations(){
    const currentRestaurant = this.$appStore.state.restaurant.selectedRestaurant;
    const latitude = currentRestaurant?.address.latitude;
    const longitude = currentRestaurant?.address.longitude;

    const mapCenter = new google.maps.LatLng(latitude!,longitude!);
    const restaurantList = (await this.$services.restaurant.restaurantSearch(mapCenter, ONE_MILE)).filter(restaurant => restaurant.address?.addressLine1 && currentRestaurant?.restaurantNumber != restaurant.restaurantNumber);
    this.isNearbyChipotle = !!restaurantList.length;
  }
}
